import React from "react";
import {useTranslation} from "react-i18next";
import Battery from "assets/img/battery_mid.png";
import BatteryFull from "assets/img/battery_full.png";
import BatteryLow from "assets/img/battery_low.png";

import './bicycles-footer-label.scss';

const BicyclesFooterLabel = (props) => {
    const {t} = useTranslation();

    return (
        <div className="bicycle-footer-label">
          <div>
            Smart Lock Battery
          </div>

          <div>
            <img src={BatteryFull} alt="Good" className="battery-icon"/> Good
          </div>

          <div>
            <img src={Battery} alt="Low" className="battery-icon"/> Low
          </div>

          <div>
            <img src={BatteryLow} alt="Charge" className="battery-icon"/> Charge
          </div>

          <div>
            Not Available <span>= Bike is not available or is dead</span>
          </div>
        </div>
    )
}

export default BicyclesFooterLabel;
